import React, { useState, useEffect, useCallback } from 'react';
import WhatsHotCard from './WhatsHotCard';
import { getVoteTimeline, fetchItemDetails, voteForPaper, likeItemOutside } from '../../utils/api';
import { Tabs, TabList, Tab, TabPanels, TabPanel, Heading } from '@chakra-ui/react';
import { format } from 'date-fns';

const WhatsHotPage = () => {
  const [papersData, setPapersData] = useState([]);
  const [selectedDateIndex, setSelectedDateIndex] = useState(0);
  const [dates, setDates] = useState([]);

  const fetchPapersAndVotes = useCallback(async () => {
    const timelineResponse = await getVoteTimeline();
    if (!timelineResponse || !timelineResponse.timeline) {
      console.error("Failed to fetch vote timeline");
      return;
    }

    const paperIds = Object.keys(timelineResponse.timeline);
    const papersDetailsPromises = paperIds.map(async (id) => {
      const details = await fetchItemDetails(id);

      // Get the latest total votes from the timeline
      const totalVotesTimeline = timelineResponse.timeline[id].total_votes;
      const totalVotes = totalVotesTimeline.length > 0 ? totalVotesTimeline[totalVotesTimeline.length - 1][1] : 0;

      return {
        id,
        title: details.title,
        authors: details.authors,
        abstract: details.abstract,
        date: details.date,
        location: details.location,
        time_start: details.time_start,
        time_end: details.time_end,
        totalVotes,
        userVoteTime: timelineResponse.timeline[id].user_vote_time ? new Date(timelineResponse.timeline[id].user_vote_time) : null,
      };
    });

    const papersDetails = await Promise.all(papersDetailsPromises);

    // Sort papers by total votes in descending order
    papersDetails.sort((a, b) => b.totalVotes - a.totalVotes);

    setPapersData(papersDetails);

    const uniqueDates = [...new Set(papersDetails.map(item => item.date))];
    uniqueDates.sort((a, b) => new Date(a) - new Date(b)); // Sort dates in ascending order
    const allDates = ['All', ...uniqueDates]; // Add 'All' tab at the start
    setDates(allDates);
  }, []);

  useEffect(() => {
    fetchPapersAndVotes();
  }, [fetchPapersAndVotes]);

  const handleAdd = async (paperId) => {
    await likeItemOutside(paperId);
    const success = await voteForPaper(paperId);
    if (success) {
      await fetchPapersAndVotes();
    }
  };

  const filteredPapers = selectedDateIndex === 0
    ? papersData
    : papersData.filter(paper => paper.date === dates[selectedDateIndex]);

  return (
    <div>
      <div className="whats-hot-page">
        <div className="paper-page-container">
          <Heading 
            as="h1" 
            size="xl" 
            className="page-title" 
            style={{
              background: 'linear-gradient(45deg, #E27A47 45%, #4BB19D 55%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            What's Hot
          </Heading>
          <Tabs isFitted variant="enclosed" index={selectedDateIndex} onChange={(index) => setSelectedDateIndex(index)}>
            <TabList className="tab-list">
              {dates.map((date, index) => (
                <Tab key={index} className={`tab ${selectedDateIndex === index ? 'tab-selected' : ''}`} fontSize="sm">
                  {date === 'All' ? 'All' : format(new Date(date), 'MMM d')}
                </Tab>
              ))}
            </TabList>
            <TabPanels>
              {dates.map((date, index) => (
                <TabPanel key={index}>
                  <div className="whats-hot-page">
                    {filteredPapers.map((paper) => (
                      <WhatsHotCard
                        key={paper.id}
                        title={paper.title}
                        authors={paper.authors}
                        abstract={paper.abstract}
                        totalVotes={paper.totalVotes}
                        onAdd={() => handleAdd(paper.id)}
                        hasVoted={!!paper.userVoteTime}
                        date={paper.date}
                        time_start={paper.time_start}
                        time_end={paper.time_end}
                        location={paper.location}
                      />
                    ))}
                  </div>
                </TabPanel>
              ))}
            </TabPanels>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default WhatsHotPage;
